import { useQuery } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { TextChannelKey } from 'types'
import { DesignChannel } from 'components/NewFileModal/Types'

type Props = { count: number }

export type RecentWizard = {
  type: 'Design' | 'Text'
  channel: TextChannelKey | DesignChannel
  width?: number | null
  height?: number | null
}

type Data = { channels: RecentWizard[] }

const fetchRecentWizards = async ({ count }: Props) => {
  return sendToApi<Data>(`/recent_wizards?limit=${count}`).then((response) => {
    if (response.type === SUCCESS_RESPONSE_TYPE) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  })
}

export const useRecentWizards = ({ count }: Props) => {
  return useQuery(['recent_wizards', count], () => fetchRecentWizards({ count }), {
    cacheTime: 1 * 60 * 1000, // 1 minute
    refetchOnWindowFocus: false,
  })
}
